"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementVisible = isElementVisible;
function isElementVisible(element) {
  let horizontalPercentVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let verticalPercentVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const rect = element?.getBoundingClientRect();
  if (!rect) {
    return {
      isHorizontallyVisible: false,
      isVerticallyVisible: false
    };
  }
  const requiredWidth = rect.width * horizontalPercentVisible;
  const requiredHeight = rect.height * verticalPercentVisible;
  return {
    isHorizontallyVisible: rect.right - requiredWidth >= 0 && rect.left + requiredWidth <= (window?.innerWidth ?? document.documentElement.clientWidth),
    isVerticallyVisible: rect.bottom - requiredHeight >= 0 && rect.top + requiredHeight <= (window?.innerHeight ?? document.documentElement.clientHeight)
  };
}